import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { paths } from '@/app/routes/paths';
import { isGuardianPortalOnly, useAuthStore } from '@/store';

/** Restricts a route to guardian-portal-only users; staff are sent to the org dashboard. */
export function RequireGuardianOnly({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);

  if (!user) {
    return null;
  }

  if (!isGuardianPortalOnly(user)) {
    return <Navigate to={paths.dashboard} replace />;
  }

  return children;
}
